<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="title-section form-section">
            <p class="page-title text-center">
            <img
              src="../../../public/assets/images/logo.png"
              alt="background image"
            >
            </p>
            <h1 class="page-extra-page-title text-center">ATTENTION OREP Customers</h1>

          </article>
          <article class="d-flex flex-column align-items-center px-4 pb-5 form-section">
            <p class="text-left" style="max-width: 795px; margin-bottom: 34px;">
              Due to the laws in your state, we cannot take your application online and you must fill out a PDF application and submit to us via Email (or fax).
            </p>
            <div class="d-flex" style="max-width: 651px;">
              <i class="legalese-fa fas fa-info-circle"></i>
              <div class="d-flex flex-column">
                <p class="more-desc-p text-left flex" style="max-width: 651px;">
                  Please download your application below and submit it via Email or Fax
                  <br />
                  Email: info@orep.org
                  <br />
                  Fax: (619) 704-0567</p>

                <button type="submit" class="next-btn-extra mont spaced pull-right" :disabled="!state.pageOneIsValid"
                        :class="{submitDisabled: !state.pageOneIsValid}" @click="downloadWithVueResource()">
                  download your application </button>

              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import { STATES } from "../../utils/constants";
var moment = require('moment')

export default {
  name: "individual-appraiser-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    individualAppraiser() {
      return this.$store.state.individualAppraiser.individualAppraiser;
    },
    state() {
      return this.$store.state.individualAppraiser;
    },
    errorMsg() {
      return this.$store.state.individualAppraiser.errorMsg;
    }
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Individual-Appraiser-Application.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithVueResource() {

      this.$http({
        method: 'get',
        url: 'https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf',
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))

    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNextCustomLink() {
      window.location("https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf", "_self");
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.individualAppraiser.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .page-desc {
    width: 295px;
    height: 45px;
  }
  .form-title {
    font-size: 35px !important;
  }
  .w-40 {
    flex: 0 0 40px;
  }
</style>
